export default {
  PleaseSelectUser: 'Please select a customer',
  OnlyCrossBorder: 'View only cross-border links',
  CrossBorderLink: 'cross-border link',
  CrossBorderNode: 'Cross-border node',
  NetTips:
    'You can perform quick networking management on a single gateway in the list, and batch modification is supported in graphical mode. \nSpecial reminder: Disabling the networking function may affect the associated policies and cause the policies and configurations to fail. Please operate with caution! If you have any questions, please consult our operation and maintenance engineer before proceeding.',
  DirectPOP: 'Direct POP',
  CPEInformation: 'CPE Information',
  name: 'name',
  model: 'model',
  peerGateway: 'Peer Gateway',
  NetworkDetail: 'Network details',
  nodePlaceholder: 'Click to view CPE and POP information',
  WhetherToUse: 'Whether To Use',
  NoneCpeIPTips: 'Unable to get due to dhcp/pppoe configuration',
  LocalCPE: 'Local CPE',
  DirectlyConnectedNode: 'Directly connected node',
  NodeIp: 'Node IP',
  PeerCPE: 'Peer CPE',
}
